var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardDetailHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "#33383D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 10C17.8344 10 16.7044 10.555 16 11.4931C15.2956 10.555 14.1656 10 12.875 10C11.8476 10.0012 10.8627 10.4098 10.1362 11.1362C9.40979 11.8627 9.00116 12.8476 9 13.875C9 18.25 15.4869 21.7913 15.7631 21.9375C15.8359 21.9767 15.9173 21.9972 16 21.9972C16.0827 21.9972 16.1641 21.9767 16.2369 21.9375C16.5131 21.7913 23 18.25 23 13.875C22.9988 12.8476 22.5902 11.8627 21.8638 11.1362C21.1373 10.4098 20.1524 10.0012 19.125 10ZM16 20.925C14.8587 20.26 10 17.2306 10 13.875C10.001 13.1128 10.3042 12.3821 10.8432 11.8432C11.3821 11.3042 12.1128 11.001 12.875 11C14.0906 11 15.1112 11.6475 15.5375 12.6875C15.5752 12.7792 15.6393 12.8576 15.7216 12.9128C15.804 12.968 15.9009 12.9975 16 12.9975C16.0991 12.9975 16.196 12.968 16.2784 12.9128C16.3607 12.8576 16.4248 12.7792 16.4625 12.6875C16.8887 11.6456 17.9094 11 19.125 11C19.8872 11.001 20.6179 11.3042 21.1568 11.8432C21.6958 12.3821 21.999 13.1128 22 13.875C22 17.2256 17.14 20.2594 16 20.925Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDetailHeart);
export default __webpack_public_path__ + "static/media/card_detail_heart.a0f9324790b6ce057e485320480dd24d.svg";
export { ForwardRef as ReactComponent };